var _circle, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTooltipIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    transform: "rotate(-180 8 8)",
    fill: "#307CAE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.77734 12.8374L9.45411 8.41905C9.45411 8.13947 9.2925 7.99967 8.96926 7.99967L7.02987 7.99967C6.70664 7.99967 6.54502 8.13947 6.54502 8.41905L6.22179 12.8374C6.22179 12.9899 6.27566 13.1043 6.3834 13.1805C6.46421 13.2822 6.57196 13.333 6.70664 13.333L9.29249 13.333C9.42718 13.333 9.54839 13.2822 9.65613 13.1805C9.73694 13.1043 9.77734 12.9899 9.77734 12.8374Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.99957 6.2218C7.51003 6.2218 7.0978 6.04145 6.76285 5.68074C6.40214 5.34579 6.22179 4.93356 6.22179 4.44402C6.22179 3.95449 6.40214 3.52937 6.76285 3.16866C7.0978 2.83372 7.51003 2.66625 7.99957 2.66625C8.4891 2.66625 8.91422 2.83372 9.27493 3.16866C9.60987 3.52937 9.77734 3.95449 9.77734 4.44402C9.77734 4.93356 9.60987 5.3458 9.27493 5.68074C8.91422 6.04145 8.4891 6.2218 7.99957 6.2218Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTooltipIcon);
export default __webpack_public_path__ + "static/media/tooltip-icon.263b1507d6b095615b2b4a491f49a01e.svg";
export { ForwardRef as ReactComponent };